import {
  CheckCircleIcon,
  FulfillmentIcon,
  OrdersIcon,
  ReturnIcon,
  WarningIcon,
  TakeIcon,
  StoreIcon,
  KeyActionIcon,
  SkuTrackerIcon,
  ShoppingBagIcon,
  AlterationIcon,
  DigitalClientLeadIcon,
  CrownIcon,
  Alerts,
  ChatsIcon,
  GroupMigrationIcon,
} from 'sharedComponents/Icons';

import * as toggles from './featureToggleNames';
import { messageTypes } from './message';

export { default as STATES_USA } from './states';
export { default as STORE_LIST } from './stores';
export { default as STORE_PHONE_LIST } from './storePhoneNumbers';
export { default as POS_LINE_ITEM_DEFAULT } from './posLineItemDefault';

export * from './checkout';
export * from './orders';
export * from './filters';
export * from './product';
export * from './search';
export * from './message';
export * from './performance';
export * from './lineItemCodes';
export * from './timezones';

export {
  PACKAGING_TYPES,
  GIFT_NOTE_TYPES,
  NOTE_OPTIONS,
  GIFT_ERRORS,
  GIFT_PACKAGING_PRICE,
  NO_GIFT_PACKAGING,
  FREE_BG_GIFT_PACKAGING,
  GIFT_PACKAGING_REGULAR,
  GIFT_PACKAGING_ELEVATED,
  GIFT_RECEIPT_TITLE,
} from './giftOptions';
export {
  DEFAULT_GROUP_DATA,
  GROUPS_SORT_BY,
  SUPERUSER_AD_GROUP,
  AD_GROUP_LIST,
  STANLEY_GROUP_ID,
  SA_MATCHES_GROUP_DATA,
  SA_MATCHES_GROUP_ID,
  STANLEY_ELIGIBLE_GROUP_DATA,
  STANLEY_ELIGIBLE_GROUP_ID,
} from './groups';
export {
  CLIENT_ONLINE_BAGS_SORT_BY,
  DEFAULT_ONLINE_BAGS_SORT_BY,
  DEFAULT_ONLINE_BAGS_FILTER_BY,
  CLIENT_ONLINE_BAG_FILTERS_BY,
  DEFAULT_ONLINE_BAG_FILTERS,
  DEFAULT_SORT,
} from './clientOnlineBags';
export { NOTES_FILTERS } from './notes';
export { STORE_HOURS } from './storeHours';

export const GROUPS = {
  MANAGER: 'G_OSP_Manager',
  STYLIST: 'G_OSP_DigitalStylist',
  TESTER: 'G_OSP_DigitalStylist_TEST',
};
export const DIGITAL_STYLIST_GROUPS = [
  'G_OSP_DigitalStylist',
  'G_OSP_NM_DigitalStylist_TEST',
  'G_OSP_NM_DIGITAL_STYLIST',
  'G_OSP_NM_DIGITAL_ClIENT_ADVISOR',
  'G_OSP_NM_DIGITAL_ClIENT_ADVISOR_TEST',
];

export const BRAND_PROFILES_LIST = ['BG', 'NM'];
export const BRAND_PROFILES = { BG: 'BG', NM: 'NM' };
export const NON_CONNECT_ISSUES_HELP_DESK_PHONE = '(844) 664-4040';
export const ONLINE_ACCOUNT_TYPES = {
  UNIVERSAL_CUSTOMER_ACCOUNT: 'UCA',
};

// String value which should be used for brand identifier of logged user through `custom:groups` prop of Cognito payload
export const BG_BRAND_IDENTIFIER = 'G_OSP_BG';

export const GROUPS_COVER_COLORS = ['#000000', '#00857c', '#ed5a61', '#a000a3', '#0069c4', '#009d69'];

export const ROLES = {
  MANAGER: 'manager',
  STYLIST: 'stylist',
  CLIENT: 'client',
  TESTER: 'tester',
};

export const VOICE_CALL_STATUS_TEXT = {
  ACCEPT: 'CALL CONNECTED',
  CONNECT: 'RINGING...',
  DIALING: 'DIALING...',
  DISCONNECT: 'DISCONNECTED',
  RECONNECTING: 'RECONNECTING',
  ERROR: 'CALL ERROR',
  MUTED: 'MUTED',
  OFFLINE: 'NOT CONNECTED OR EXPIRED TOKEN',
};

export const NEW_TWILIO_ERROR_CODE = {
  GENERIC_ERROR: 31000,
  CONNECTION_ERROR: 31005,
  MICROPHONE_ERROR: 31402,
  JWT_INVALID: 31204,
  JWT_EXPIRED: 31205,
  ACCESS_TOKEN_INVALID: 20101,
  ACCESS_TOKEN_EXPIRED: 20104,
  DENIED_MICROPHONE: 31401,
  ICE_CONNECTION_FAIL: 53405,
  WEBSOCKET_TIMEOUT_PREFLIGHT: 53000,
};

export const STYLYZE_LOOKS_LINKS = [
  { title: 'My Looks', key: 'my-looks' },
  { title: "Discover Women's", key: 'womens-looks' },
  { title: "Discover Men's", key: 'mens-looks' },
  { title: 'Discover Beauty', key: 'beauty-looks' },
  { title: 'Discover Kids', key: 'kids-looks' },
  { title: 'Resort 2022', key: 'context-group', toggle: toggles.RESORT_22_LOOK_CATEGORY },
  {
    title: 'Holiday 2022',
    key: 'context-group',
    toggle: toggles.HOLIDAY_LOOK_CATEGORY,
    showForBrand: BRAND_PROFILES.NM,
  },
];

export const STYLYZE_EDIT_CATEGORIES = [
  { title: 'My Edits', key: 'MY_EDITS', toggle: toggles.MY_EDITS_ENHANCEMENT, isHiddenForBG: true },
  { title: 'Product Spotlight', key: 'PRODUCT_SPOTLIGHT' },
  { title: 'Look Story', key: 'LOOK_STORY' },
  { title: 'Collection', key: 'COLLECTION' },
  { title: 'The Refresh', key: 'REFRESH_EDITS' },
  {
    title: 'Holiday 2022',
    key: 'GIFT_1,GIFT_4,GIFT_9',
    toggle: toggles.EDITS_HOLIDAY_CATEGORY,
  },
];

// export const logoutUrl = (authConfig) =>
//   `https://${authConfig.oauth.domain}/logout?client_id=${authConfig.userPoolWebClientId}` +
//   `&redirect_uri=http://localhost:3000/logout&response_type=${authConfig.oauth.responseType}`;

// TODO: Fix Amplify logout flow

/*export const logoutUrl = (authConfig) =>
  `https://${authConfig.oauth.domain}/logout?client_id=${authConfig.userPoolWebClientId}` +
  `&redirect_uri=http://localhost:3000/logout&response_type=${authConfig.oauth.responseType}&identity_provider=${authConfig.oauth.responseType}`;*/

// export const logoutUrl = (authConfig) =>
//     `https://${authConfig.oauth.domain}/logout?client_id=${authConfig.userPoolWebClientId}` +
//     `&redirect_uri=${authConfig.oauth.redirectSignOut}&response_type=${authConfig.oauth.responseType}`;

// export const logoutUrl = (authConfig) =>
//   `https://${authConfig.oauth.domain}/logout?client_id=${authConfig.userPoolWebClientId}` +
//   `&redirect_uri=${authConfig.oauth.redirectSignOut}&response_type=${authConfig.oauth.responseType}&logout_uri=${authConfig.oauth.redirectSignOut}`;

export const logoutUrl = (authConfig) =>
  `https://${authConfig.oauth.domain}/logout?client_id=${authConfig.userPoolWebClientId}` +
  `&logout_uri=${authConfig.oauth.redirectSignOut}`;

export const NMVIP = 'NMVIP';

export const shipmentMethodsMap = [
  {
    id: 'SL0',
    name: 'Same Day Delivery',
    term: 'Order by noon, weekdays only',
    value: '35.00',
  },
  {
    id: 'SL1',
    name: 'Next Business Day',
    term: '1-2 business days',
    value: '25.00',
  },
  {
    id: 'SL2',
    name: 'Two Day Shipping',
    term: '2-3 business days',
    value: '15.00',
  },
  {
    id: 'SL3',
    name: 'Standard Delivery',
    term: '3-5 business days',
    value: '0.00',
  },
  {
    id: 'SL4',
    name: 'Economy',
    term: '5-8 business days',
    value: '0.00',
  },
];

export const PHONE_TYPES = [
  { name: 'Phone', value: 'phone' },
  { name: 'Mobile', value: 'mobile' },
  { name: 'Home', value: 'home' },
];

export const statusCodesMap = {
  RP: { type: 'Placed', text: 'Ready to Print' },
  RD: { type: 'Placed', text: 'Ready to Dropship' },
  DS: { type: 'In-fulfillment', text: 'Dropship' },
  PT: { type: 'In-fulfillment', text: 'Printed Warehouse or Store Ticket' },
  VS: { type: 'Shipped', text: 'Verified Shipped' },
  BO: { type: 'Issue', text: 'Back Ordered' },
  VOID: { type: 'Issue', text: 'Void' },
  CX: { type: 'Issue', text: 'Cancelled', isNegative: true },
  RT: { type: 'Returned', text: 'Returned Product Received', icon: 'Returned', isNegative: true },
  RX: { type: 'Returned', text: 'Return Credit before Merchandise Received', icon: 'Returned', isNegative: true },
  RN: {
    type: 'Returned',
    text: 'Return Credit without the expectation of Merchandise ever coming back',
    icon: 'Returned',
    isNegative: true,
  },
  PL: { type: 'Issue', text: 'Parcel Loss', isNegative: true },
  PD: { type: 'Issue', text: 'Parcel Damage', isNegative: true },
  RB: { type: 'Issue', text: 'Reply Back' },
  CB: {
    type: 'Issue',
    text: 'Customer Charge Back',
    isNegative: true,
  },
  RI: { type: 'Ignore', text: 'Reintstated' },
  RETURN: { type: 'Returned', text: 'Returned Product Received', icon: 'Returned', isNegative: true },
  SEND: { type: 'Send', text: '' },
  TAKE: { type: 'Take', text: '' },
  BOPS: { icon: 'BOPS' },
  1000: { type: 'Placed', text: 'Created' },
  1500: { type: 'Placed', text: 'Backordered (No Inventory)' },
  2000: { type: 'Placed', text: 'Allocated' },
  3000: { type: 'Placed', text: 'Released' },
  3500: { type: 'Placed', text: 'In Process' },
  3500.1: { type: 'Placed', text: 'Containerized' },
  3600: { type: 'Placed', text: 'Picked' },
  3700: { type: 'Placed', text: 'Packed' },
  7000: { type: 'Shipped', text: 'Shipped' },
  7500: { type: 'Shipped', text: 'Delivered' },
  8000: { type: 'Shipped', text: 'Return Initiated' },
  8500: { type: 'Returned', text: 'Returned/Refunded', isNegative: true },
  9000: { type: 'Issue', text: 'Cancelled', isNegative: true },
  19000: { type: 'Issue', text: 'Return Cancelled', isNegative: true },
};

const cancelledDueToPossibleFraud = 'Cancelled. Do NOT re-ring. Contact LP with questions.';

export const cancelCodesMap = {
  CXA: 'Canceled because of no response from customer to a notice sent which required a response (other than backorder)',
  CXB: 'Canceled due to insufficient funds on personal check',
  CXBO: 'Cancelled due to back order. (This code cannot be keyed by associates.)',
  CXC: "Canceled at customer's request (Do not use for associate errors)",
  CXCF: 'Canceled confirmed fraud',
  CXD: 'Canceled - item is discontinued - no more available from vendor',
  CXE: 'Order cancelled due to an exception. Please read notemail on the order for details',
  CXF: 'Canceled because customer did not consent to backorder delay',
  'CXF-FTC': 'Canceled by system because of no response from customer regarding backorder letter or phone call',
  CXFA: cancelledDueToPossibleFraud,
  CXFP: cancelledDueToPossibleFraud,
  CXH: 'Canceled by customer due to Delivery and Processing costs',
  CXI: 'Precious Jewelry item being fulfilled from the store',
  CXN: 'Canceled by NMD. Buyers have determined the item is no longer available',
  CXNB: 'Canceled - No more business - Do not use - CMOS auto-assigns',
  CXND: 'Canceled - System Issue Non-Demand',
  CXO: 'Canceled by operator',
  CXP: 'Canceled - no payment received (usually on mailed/faxed orders)',
  CXPF: cancelledDueToPossibleFraud,
  CXPO: 'Canceled - Confirms Drop Ship merchandise canceled by Vendor.',
  CXPP: 'Canceled - Request for exchange, however customer used PayPal as payment method and we cannot process exchanges with PayPal. Customer must go online and place a new order for the exchange item.',
  CXPV: 'Cancelled Store Post Void',
  CXQ: 'Canceled - merchandise not up to quality standards - NMD will not ship',
  CXR: 'Canceled by credit - credit card company did not approve the charge',
  CXRA: 'Canceled - Referral hold - no response by customer after a maximum of 5 days and 3 days for SL1 orders.',
  CXRC: 'Canceled Replenishment Service - cancelled due to credit issue',
  CXRD: 'Canceled Replenishment Service - cancelled because the Replenishment SKU is discontinued and stock is depleted',
  CXRP: 'Canceled Replenishment Service - cancelled by the customer',
  CXS: 'Canceled due to set up error. Check CMOS for new order',
  CXSI: 'Canceled Shared Inventory - Order could not be filled via Shared Inventory',
  CXSP: 'Canceled due to unavailable inventory in selected store for store pickup',
  CXSR: 'Canceled Replenishment Service - skipped shipment by customer',
  CXSV: 'Canceled due to Store Void',
  CXU: 'Canceled undeliverable. Usually an invalid address for merchandise type',
  CXUF: cancelledDueToPossibleFraud,
  CXV: 'Canceled by vendor - vendor no longer makes this item',
  CXZ: cancelledDueToPossibleFraud,
};

export const ICON_COLORS = {
  GREEN: '#009d69',
  ORANGE: '#ef6c00',
  RED: '#b00000',
};

export const bopsSubStatusMap = {
  'store allocation': ICON_COLORS.ORANGE,
  'found on floor': ICON_COLORS.ORANGE,
  'in transit': ICON_COLORS.GREEN,
  'delivered to store': ICON_COLORS.GREEN,
  'ready for pick up': ICON_COLORS.GREEN,
  'package picked up': ICON_COLORS.GREEN,
  'item returned': ICON_COLORS.GREEN,
};

export const ICON_MAP = {
  Placed: {
    icon: CheckCircleIcon,
    color: ICON_COLORS.ORANGE,
  },
  'In-fulfillment': {
    icon: FulfillmentIcon,
    color: ICON_COLORS.ORANGE,
  },
  Shipped: {
    icon: OrdersIcon,
    color: ICON_COLORS.GREEN,
  },
  Returned: {
    icon: ReturnIcon,
    color: ICON_COLORS.RED,
  },
  Issue: {
    icon: WarningIcon,
    color: ICON_COLORS.RED,
  },
  Ignore: {
    icon: WarningIcon,
    color: ICON_COLORS.RED,
  },
  Send: {
    icon: OrdersIcon,
    color: ICON_COLORS.GREEN,
  },
  Take: {
    icon: TakeIcon,
    color: ICON_COLORS.GREEN,
  },
  BOPS: {
    icon: StoreIcon,
    color: ICON_COLORS.GREEN,
  },
};

export const PRICE_ADJUST = {
  MAX_PRICE: 0.3,
  ERROR_MSG: 'Cannot adjust more than 30%',
  INVALID_MSG: 'Invalid adjustment',
  ERROR_MSG_MAX_LENGTH_256: 'Max length is 256 symbols',
  ERROR_MSG_REQUIRED: 'Required',
  CONCIERGE_TYPES: [
    { value: 'DOLLAR', name: 'Dollar Off' },
    { value: 'PERCENT', name: 'Percent Off' },
    { value: 'OVERRIDE', name: 'Price override' },
  ],
  TYPES: [
    { value: 'DOLLAR', name: 'Dollar Off' },
    { value: 'PERCENT', name: 'Percent Off' },
    { value: 'OVERRIDE', name: 'Price override' },
    { value: 'ADJUSTMENT', name: 'Price Adjustment' },
  ],
  TYPES_CHARS: {
    DOLLAR: '- $',
    PERCENT: '%',
    OVERRIDE: '$',
    ADJUSTMENT: '$$',
  },
  CONCIERGE_REASONS: [
    { value: 'Competitive Price Match', name: 'Competitive Price Match' },
    { value: 'Omni Price Match', name: 'Omni Price Match' },
    { value: 'Promotion Error', name: 'Promotion Error' },
  ],
  REASONS: [
    { value: 'Competitive Price Match', name: 'Competitive Price Match' },
    { value: 'Omni Price Match', name: 'Omni Price Match' },
    { value: 'Promotion Error', name: 'Promotion Error' },
    { value: 'Incorrect Dollar Value', name: 'Incorrect Dollar Value' },
  ],
  PAYLOAD: {
    DOLLAR: 'DOLLAR_OFF',
    PERCENT: 'PERCENT_OFF',
    OVERRIDE: 'MARKDOWN_NEWPRICE',
    ADJUSTMENT: 'ADD_NEWPRICE',
  },
};

export const NO_IMAGE_AVAILABLE = {
  NM: '/no_image_available_nm.jpeg',
  BG: '/no_image_available_bg.png',
};

export const SWATCH_PLACEHOLDER = {
  NM: '/swatch_NM.jpg',
  BG: '/swatch_BG.jpg',
};

export const IMAGE_HEAD_PROTOCOL = 'https:';

export const DEFAULT_PAGE_SIZE = 40;

export const DEFAULT_EDIT_GALLERY_PAGE_SIZE = 12;

export const DESIGNER_CATEGORY_IDS = [
  'cat000019',
  'cat000199',
  'cat000160',
  'cat000339',
  'cat59430736',
  'cat000226',
  'cat000488',
  'cat000562',
];

export const BG_DESIGNER_CATEGORY_IDS = ['cat000001'];

export const PLP_SORTING_FILTERS = [
  {
    name: 'Recommended',
    sortBy: 'BESTRECOMMENDED',
    sortDirection: '',
  },
  {
    name: 'Best Match',
    sortBy: '',
    sortDirection: '',
  },
  {
    name: 'Price: Lowest first',
    sortBy: 'PRICE',
    sortDirection: 'ASC',
  },
  {
    name: 'Price: Highest first',
    sortBy: 'PRICE',
    sortDirection: 'DESC',
  },
  {
    name: 'Newest first',
    sortBy: 'CREATED',
    sortDirection: 'DESC',
  },
  {
    name: 'Oldest first',
    sortBy: 'CREATED',
    sortDirection: 'ASC',
  },
];

export const OFFSET_TOP_TO_SHOW_BACK_TO_TOP = 100;

export const PIMSKU_MAX_LENGTH = 20;

export const PAYMENT_IFRAME_HEIGHT = '316px';

export const GLOBAL_SEARCH_MODULES = [
  {
    name: 'clients',
    path: '/clients/central/search',
  },
  {
    name: 'orders',
    path: '/orders',
    state: { clearFilters: true },
    hideConditions: ['isBackOfHouseUser'],
  },
  {
    name: 'products',
    path: '/products/catalog/search',
  },
  {
    name: 'messages',
    path: 'clienteling/inbox',
    hideConditions: ['isBackOfHouseUser'],
  },
  {
    name: 'trackers',
    path: '/products/catalog/tracker',
  },
];

export const GLOBAL_NAVIGATION_TABS = {
  home: {
    path: '/home',
  },
  search: {
    path: '/search',
  },
  messages: {
    path: '/clienteling',
  },
  alerts: {
    path: '/notifications',
  },
  style: {
    path: '/products',
  },
  clients: {
    path: '/clients',
  },
};

export const NOTIFICATIONS_FILTER = [
  {
    value: 'ALTERATION',
    name: 'Alterations',
    icon: AlterationIcon,
  },
  {
    value: 'APPOINTMENT',
    name: 'Appointments',
    icon: Alerts,
  },
  {
    value: 'RTC',
    name: 'Client Connects',
    icon: KeyActionIcon,
  },
  {
    value: 'SM_GROUP_MIGRATION',
    name: 'Group Migration',
    icon: GroupMigrationIcon,
  },
  {
    value: 'DIGITAL_CLIENT_LEAD',
    name: 'Matched Clients',
    icon: DigitalClientLeadIcon,
  },
  {
    value: 'NMVIP',
    name: 'NMVIP',
    icon: CrownIcon,
  },
  {
    value: 'BG_CONCIERGE',
    name: 'BG Concierge',
    icon: DigitalClientLeadIcon,
  },
  {
    value: 'NEW_CHAT_CLIENT',
    name: 'Chat Clients',
    icon: ChatsIcon,
  },
  {
    value: 'ORDER',
    name: 'Orders',
    icon: OrdersIcon,
  },
  {
    value: 'ONLINEBAG',
    name: 'Shared Shopping Bags',
    icon: ShoppingBagIcon,
  },
  {
    value: 'SKUV2',
    name: 'SKU Tracker',
    icon: SkuTrackerIcon,
  },
];

export const NOTIFICATIONS_POSTPONE = [
  {
    value: '3h',
    name: 'Later today',
  },
  {
    value: '24h',
    name: 'Tomorrow',
  },
  {
    value: '7d',
    name: 'Next Week',
  },
];

export const LOYALTY_CARD_LABELS = {
  'Promotional Card': 'Promo Card',
  'InCircle Point Card': 'Point Card',
  'InCircle Perk': 'Perk Card',
};

export const ATTACHMENTS_SIZE_LIMIT = {
  [messageTypes.email]: {
    file: 9,
    message: 10,
  },
  [messageTypes.sms]: {
    file: 20,
    message: 10,
  },
  [messageTypes.chat]: {
    file: 20,
    message: 10,
  },
};

export const ATTACHMENTS_ACCEPT_TYPES = '.png,.jpg,.gif,.pdf';

/**
 * @see [OSP-7835] AC1
 */
const ATTACHMENTS_ACCEPT_IMAGE_TYPES = ['.jpeg', '.jpg', '.gif', '.png', '.bmp', '.tiff'];
const ATTACHMENTS_ACCEPT_VIDEO_TYPES = ['.mpeg', '.mp4', '.mov'];
const ATTACHMENTS_ACCEPT_DOCUMENT_TYPES = ['.pdf'];
export const ATTACHMENTS_ACCEPT_TYPES_NEW = [
  ...ATTACHMENTS_ACCEPT_IMAGE_TYPES,
  ...ATTACHMENTS_ACCEPT_VIDEO_TYPES,
  ...ATTACHMENTS_ACCEPT_DOCUMENT_TYPES,
].join(',');

export const VALID_CHAT_ATTACHMENTS = [
  'jpeg',
  'jpg',
  'gif',
  'png',
  'bmp',
  'tiff',
  'mpeg',
  'mp4',
  'mov',
  '3gp',
  'pdf',
  'quicktime',
];

export const VALID_SMS_ATTACHMENTS = ['jpeg', 'jpg', 'gif', 'png', 'bmp', 'tiff', 'mpeg', 'mp4', 'mov', 'pdf'];

export const COGNITO_EMAIL_VALIDATION = {
  RESPONSE_TYPES: {
    EXISTS: 'UsernameExistsException',
    INVALID: 'UserLambdaValidationException',
  },
  ERROR_TYPES: {
    EXISTED: 'existed email',
    INVALID: 'invalid email',
    ERROR: 'error',
  },
};

export const OSP_PRODUCT_SHARE_EXPIRY = 'osp_lxts';

export const OSP_PRODUCT_SHARE_EXPIRY_DATE = 30;

export const DAYS_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const CLIENT_CREATION_MESSAGE_SUBJECTS = {
  NM: {
    clientCreation: 'Welcome to Neiman Marcus!',
    cmdLinking: 'Your Neiman Marcus account has been updated',
  },
  BG: {
    clientCreation: 'Welcome to Bergdorf Goodman!',
    cmdLinking: 'Your Bergdorf Goodman account has been updated',
  },
};

// Added FF root cat ids for Farfetch integration
export const PRODUCT_ROOT_CATEGORY_IDS = {
  BG: {
    men: 'cat202802',
    women: 'cat01',
    home: 't2cat392904',
    ffmen: '176469',
    ffwomen: '176404',
    ffhome: '176697',
    ffbeauty: '176748',
    ffkids: '176516',
  },
  NM: {
    men: 'cat000470',
    women: 'cat01',
    home: 'cat000553',
  },
};

export const BRAND_TITLES = {
  BG: 'Bergdorf Goodman',
  NM: 'Neiman Marcus',
};

export const INBOX_FILTER = [
  {
    value: 'unread',
    name: 'Unread By Client',
  },
  {
    value: 'undelivered',
    name: 'Not Delivered to Client',
  },
];

export const MESSAGE_TYPE_FILTER_MAP = {
  SMS: {
    value: 'sms',
    name: 'SMS',
  },
  EMAIL: {
    value: 'email',
    name: 'Email',
  },
  CHAT: {
    value: 'chat',
    name: 'Chat', // should be deleted when isRenameChatMessageEnabled toggle will be decommissioned
  },
  RENAMED_CHAT: {
    value: 'chat',
    name: 'NM App Message',
  },
  VOICE: {
    value: 'voice',
    name: 'Voice call',
  },
};

export const MESSAGE_STATUS_FILTER_MAP = {
  UNREAD_ASSOCIATE: {
    value: 'associateUnread',
    name: 'Unread by Me',
  },
  UNREAD_CLIENT: {
    value: 'unread',
    name: 'Unread by Client',
  },
  NOT_DELIVERED: {
    value: 'undelivered',
    name: 'Not Delivered to Client',
  },
};

/**
 * date filter
 * @typedef {Object} DateFilterType
 * @property {string} value
 * @property {string} name
 * @property {number} [offsetInDays]
 */

const TODAY = {
  value: 'TODAY',
  name: 'Today',
  offsetInDays: 0,
};

const WEEK_TO_DATE = {
  value: 'WEEK_TO_DATE',
  name: 'Week to Date',
  offsetInDays: 7,
};

const MONTH_TO_DATE = {
  value: 'MONTH_TO_DATE',
  name: 'Month to Date',
  offsetInDays: 30,
};

const QUARTER_TO_DATE = {
  value: 'QUARTER_TO_DATE',
  name: 'Quarter to Date',
  offsetInDays: 91,
};

// Season to date filter for Manager Sales Page
const SEASON_TO_DATE = {
  value: 'SEASON_TO_DATE',
  name: 'Season to Date',
};

const YEAR_TO_DATE = {
  value: 'YEAR_TO_DATE',
  name: 'Year to Date',
  offsetInDays: 365,
};

const CUSTOM_DATE_RANGE = {
  value: 'CUSTOM',
  name: 'Custom Range',
};

/**
 * @type {DateFilterType[]}
 */
export const PERFORMANCE_FILTER = [
  TODAY,
  WEEK_TO_DATE,
  MONTH_TO_DATE,
  QUARTER_TO_DATE,
  SEASON_TO_DATE,
  YEAR_TO_DATE,
  CUSTOM_DATE_RANGE,
];

export const DATE_PICKER_OPTIONS = PERFORMANCE_FILTER.map(({ value }) => value);

export const PERFORMANCE_ASSOCIATE_FILTER = [
  {
    value: 'WEEK_TO_DATE',
    name: 'This Week',
  },
  {
    value: 'MONTH_TO_DATE',
    name: 'This Month',
  },
  {
    value: 'QUARTER_TO_DATE',
    name: 'This Quarter',
  },
  {
    value: 'YEAR_TO_DATE',
    name: 'This Year',
  },
];

export const PERFORMANCE_DEFAULT_DATES = {
  today: 'TODAY',
  customRange: 'CUSTOM',
  seasonToDate: 'SEASON_TO_DATE',
};

export const LAST_YEAR = 'LY';
export const LAST_LAST_YEAR = 'LLY';

// The maximum length of search query, when search request should still not be sent.
export const SEARCH_LENGTH_THRESHOLD = 2;

export const STORE_MANAGER_LIST = {
  '0001': {
    brand: 'NM',
    storeId: '0001',
    storeName: 'Dallas - Downtown',
  },
  '0002': {
    brand: 'NM',
    storeId: '0002',
    storeName: 'Dallas - Northpark',
  },
  '0003': {
    brand: 'NM',
    storeId: '0003',
    storeName: 'Fort Worth',
  },
  '0004': {
    brand: 'NM',
    storeId: '0004',
    storeName: 'Houston Galleria',
  },
  '0005': {
    brand: 'NM',
    storeId: '0005',
    storeName: 'Bal Harbour',
  },
  '0006': {
    brand: 'NM',
    storeId: '0006',
    storeName: 'Atlanta',
  },
  '0007': {
    brand: 'NM',
    storeId: '0007',
    storeName: 'St. Louis',
  },
  '0009': {
    brand: 'NM',
    storeId: '0009',
    storeName: 'Northbrook',
  },
  '0010': {
    brand: 'NM',
    storeId: '0010',
    storeName: 'Beverly Hills',
  },
  '0011': {
    brand: 'NM',
    storeId: '0011',
    storeName: 'Fashion Island',
  },
  '0012': {
    brand: 'NM',
    storeId: '0012',
    storeName: 'San Francisco',
  },
  '0013': {
    brand: 'NM',
    storeId: '0013',
    storeName: 'Willow Bend',
  },
  '0014': {
    brand: 'NM',
    storeId: '0014',
    storeName: 'Westchester',
  },
  '0015': {
    brand: 'NM',
    storeId: '0015',
    storeName: 'Las Vegas',
  },
  '0016': {
    brand: 'NM',
    storeId: '0016',
    storeName: 'San Diego',
  },
  '0017': {
    brand: 'NM',
    storeId: '0017',
    storeName: 'Oakbrook',
  },
  '0019': {
    brand: 'NM',
    storeId: '0019',
    storeName: 'Michigan Ave',
  },
  '0020': {
    brand: 'NM',
    storeId: '0020',
    storeName: 'Boston',
  },
  '0023': {
    brand: 'NM',
    storeId: '0023',
    storeName: 'Tysons Galleria',
  },
  '0024': {
    brand: 'NM',
    storeId: '0024',
    storeName: 'Palo Alto',
  },
  '0025': {
    brand: 'NM',
    storeId: '0025',
    storeName: 'Short Hills',
  },
  '0027': {
    brand: 'NM',
    storeId: '0027',
    storeName: 'Denver',
  },
  '0028': {
    brand: 'NM',
    storeId: '0028',
    storeName: 'Paramus',
  },
  '0029': {
    brand: 'NM',
    storeId: '0029',
    storeName: 'Scottsdale',
  },
  '0030': {
    brand: 'NM',
    storeId: '0030',
    storeName: 'King of Prussia',
  },
  '0031': {
    brand: 'NM',
    storeId: '0031',
    storeName: 'Ala Moana',
  },
  '0033': {
    brand: 'NM',
    storeId: '0033',
    storeName: 'Troy',
  },
  '0034': {
    brand: 'NM',
    storeId: '0034',
    storeName: 'Coral Gables',
  },
  '0035': {
    brand: 'NM',
    storeId: '0035',
    storeName: 'Tampa Bay',
  },
  '0036': {
    brand: 'NM',
    storeId: '0036',
    storeName: 'Orlando',
  },
  '0037': {
    brand: 'NM',
    storeId: '0037',
    storeName: 'San Antonio',
  },
  '0038': {
    brand: 'NM',
    storeId: '0038',
    storeName: 'Boca Raton',
  },
  '0101': {
    brand: 'NM',
    storeId: '0101',
    storeName: 'Austin',
  },
  '0102': {
    brand: 'NM',
    storeId: '0102',
    storeName: 'Charlotte',
  },
  '0103': {
    brand: 'NM',
    storeId: '0103',
    storeName: 'Natick',
  },
  '0105': {
    brand: 'NM',
    storeId: '0105',
    storeName: 'Topanga',
  },
  '0111': {
    brand: 'NM',
    storeId: '0111',
    storeName: 'Roosevelt Field',
  },
  '0063': {
    brand: 'BG',
    storeId: '0063',
    storeName: "BG Women's Store",
  },
  '0064': {
    brand: 'BG',
    storeId: '0064',
    storeName: "BG Men's Store",
  },
};

export const DEFAULT_GM_STORE = {
  NM: STORE_MANAGER_LIST['0002'],
  BG: STORE_MANAGER_LIST['0063'],
};

export const DEFAULT_USER_IMAGE_MAP = {
  NM: '/logo_NM.jpg',
  BG: '/logo_BG.jpg',
  NMVIP: '/logo_NMVIP.jpg',
};

export const PHONE_NUM_REGEX = new RegExp(/^\d{0,10}$/);

export const NON_DIGIT_REGEX = new RegExp(/\D/g);

export const CHAT_STATUS_MAP = {
  AVAILABLE: true,
  UNAVAILABLE: false,
  UNKNOWN: undefined,
};
export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MIN_NAME_LENGTH_CC_FORM = 2;
export const NAME_REGEX = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

// Phone Number Formats
export const PHONE_NUM_EXTENDED_REGEX = /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const INTERNATIONAL_PHONE_REGEX = /^(\+|00|0|\d|\()?[1-9][0-9-.()]{9,13}$/;
export const ONLINE_ORDER_NUMBER_REGEX = /^[A-Za-z]{2}[A-Za-z0-9]{10,12}$/; // WN73222144T1
export const CONNECT_ORDER_NUMBER_REGEX = /^OSP|osp[0-9]{4,15}$/; // OSP000000001006448
export const CMOS_ORDER_NUMBER_REGEX = /^(CM|cm)?[0-9]{8,10}$/; // 32499789 || CM32499789
export const UPC_PIM_SKU_REGEX = /^[0-9]{5,16}$/;
export const ASSOCIATE_PIN_REGEX = /^[0-9]{5,6}$/;
export const STANLEY_ORDER_NUMBER_REGEX = /^STA|sta[0-9]{4,15}$/; // STA000000001006448
export const MAO_ORDER_REGEX = /^[a-zA-Z0-9]{4,10}$/; // HC10511

export const MIN_NAME_LENGTH = 3;

// Maximum char count for SMS
export const MAX_LIMIT_LOOKS_MESSAGE = 650;

// Maximum number of attachments in SMS

export const MAX_PRODUCTS_FOR_SMS_SHARING = 5;
export const MAX_ASSETS_FOR_SMS_SHARING = 5;
export const MAX_LOOKS_FOR_SMS_SHARING = 1;
export const MAX_FILES_FOR_SMS_SHARING = 10;

export const LOYALTY_CARD_TYPES = {
  NEX: 'NEX',
  IN_CIRCLE_PERK: 'InCircle Perk',
};

export const AURUS_GIFT_CARD_TYPES = {
  GCC: 'GCC',
};

export const TRANSACTION_TYPES = {
  TAKES: 'TAKES',
  SENDS: 'SENDS',
};

export const LINE_ITEMS = {
  LIMIT: 20,
  ERROR_MESSAGE: 'Maximum product limit reached. Additional items cannot be added.',
};

export const GIFT_CARD_SELECTION_CAP = 9;

export const EXTENSION_TYPES = {
  PDF: 'pdf',
  DOC: 'doc',
  DOCX: 'docx',
  TXT: 'txt',
  XLX: 'xls',
  XLSX: 'xlsx',
  MPEG: 'mpeg',
  MOV: 'mov',
  TIFF: 'tiff',
  HEIC: 'heic',
  MP4: 'mp4',
};

export const FILE_TYPES = {
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  TXT: 'text/plain',
  XLX: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const ALTERATIONS_KEY_LABEL_MAP = {
  completed: 'completed',
  overdue: 'overdue',
  inProgress: 'in progress',
};

export const PRODUCT_LIMIT_FOR_CHAT = 5;

export const LOOKS_NOTIFICATION_MESSAGES = {
  MORE_THAN_FIVE: {
    title: 'Too Many Products',
    message: `When sharing through Chat, a look can only have ${PRODUCT_LIMIT_FOR_CHAT} products. Please select the items you would like to delete and try again.`,
  },
  LESS_THAN_FIVE: {
    title: 'Not Enough Products',
    message: `You must share ${PRODUCT_LIMIT_FOR_CHAT} products in a look. Please select the items you would like to add and try again.`,
  },
};

export const DEFAULT_ACCOUNT_ASSOCIATE_WIDGET_SETTING = {
  reminders: true,
  todaysSales: true,
  recentOrders: true,
  alterations: true,
  memos: true,
};

export const ASSOCIATE_NOT_FOUND_EXCEPTION = 'Associate not found : Error: ItemNotFoundException: No item with the key';

export const LOOK_LIMIT_NOTIFICATION = {
  id: `add-${Date.now()}`,
  message: 'You have chosen the maximum number of products to create a Look. (10 products maximum)',
  iconType: 'warning',
  direction: 'bottomCenter',
  snackBarContentStyle: true,
  duration: 3000,
};

export const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const DEFAULT_COUNTRY_SELECTED = {
  value: 'US',
  name: 'United States',
};

export const DEFAULT_ADDRESS = {
  city: '',
  line1: '',
  line2: '',
  phone: '',
  state: '',
  zip: '',
  provinceOrState: '',
  country: '',
};

export const NOTIFICATION_DEFAULT_PAGE_SIZE = 40;
export const HAS_ONLY_WHITESPACES = /^\s*$/;
export const VALID_US_ZIP = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const MAX_LENGTH = 75;

export const TEMPLATE_WITH_SIGNATURE = ['/email-look-template'];
export const TWO_COLUMNS_GRID = 2;
export const THREE_COLUMNS_GRID = 3;
export const ZERO_TRANSITION_DURATION = 0;
export const DEFAULT_NUM_OF_STYLEBOARDS_RECEIVED = 12;

export const MY_EDITS_APPROVED_FILTER_CATEGORY = 'APPROVED';
export const MY_EDITS_STATUS_PUBLIC = 'Public';
export const EDITS_CATEGORY = {
  MY_EDITS: 'My_Edits',
  PRODUCT_SPOTLIGHT: 'Product_Spotlight',
  LOOK_STORY: 'Look_Story',
  REFRESH_EDITS: 'The_Refresh',
  COLLECTION: 'Collection',
  GIFT_1: 'Product_Spotlight',
  GIFT_4: 'CollectionWith4Products',
  GIFT_9: 'CollectionWith9Products',
  HOLIDAY: 'Holiday_2022',
};
export const HOLIDAY_EDITS_FILTERS_OPTIONS = {
  PRODUCT_SPOTLIGHT: { title: 'Holiday Product Spotlight', key: 'GIFT_1' },
  HOLIDAY_4: { title: 'Holiday 4 Collection', key: 'GIFT_4' },
  HOLIDAY_9: { title: 'Holiday 9 Collection', key: 'GIFT_9' },
};

export const EDIT_AVAILABILITY_LABEL_MAP = {
  'In Stock': 'In Stock',
  'Pre - Order': 'Pre Order',
  'Back - Order': 'Back Order',
  'Item Unavailable': 'Item Unavailable',
  'Ships from Vendor': 'Ships from Vendor',
  'In Store Only - In Stock': 'In Store Only - In Stock',
  'In Store Only - Item Unavailable': 'In Store Only - Item Unavailable',
};

export const EDIT_AVAILABILITY_LABEL_DATE_MAP = {
  'Pre - Order': 'Expected to ship',
  'Back - Order': 'Expected to ship',
  'Ships from Vendor': 'Expected to ship',
};

export const EDIT_AVAILABILITY_DISPLAY_DATE = {
  'Pre - Order': true,
  'Back - Order': true,
  'Ships from Vendor': true,
};

export const INSTORE_SHIPPING_METHODS = {
  BG: [
    {
      id: 'SL1',
      name: 'Surface',
      term: '5-7 business days',
    },
    {
      id: 'SL2',
      name: 'Messenger',
      term: '3-5 hours once brought to shipping',
    },
    {
      id: 'SL3',
      name: 'Next day',
      term: 'Delivered the next day by 8pm',
    },
    {
      id: 'SL4',
      name: 'Next day Am or Saturday',
      term: 'Next day by noon',
    },
    {
      id: 'SL5',
      name: '2nd Day Air',
      term: '',
    },
    {
      id: 'SL7',
      name: 'Oversize /Puerto Rico',
      term: '5-7 Business days',
    },
  ],
  NM: [
    {
      id: 'SL1',
      name: 'Surface Under $1500',
      term: '1-2 business days',
    },
    {
      id: 'SL2',
      name: 'Surface Over $1500',
      term: '2-3 business days',
    },
    {
      id: 'SL3',
      name: 'Messenger',
      term: '3-5 hours once brought to shipping',
    },
    {
      id: 'SL4',
      name: 'Next day',
      term: 'Delivered the next day by 8pm',
    },
    {
      id: 'SL5',
      name: 'Next day Am or Saturday',
      term: 'Next day by noon',
    },
    {
      id: 'SL6',
      name: '2nd Day Air',
      term: '',
    },
    {
      id: 'SL8',
      name: 'Oversize /Puerto Rico',
      term: '5-7 Business days',
    },
  ],
};

export const ECID = {
  NM_LOOKS: {
    header: 'NMCO_HD_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareNMLogo',
    logo: 'NMCO_CD_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareNMLogo',
    card: 'NMCO_BX_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareLook',
    desc: 'NMCO_CX_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareLookDesc',
  },
  BG_LOOKS: {
    header: 'BGCO_HD_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareBGLogo',
    logo: 'BGCO_CD_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareBGLogo',
    card: 'BGCO_BX_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareLook',
    desc: 'BGCO_CX_XXXX_SHLS_XXXXXXXXXXXXXXXX_XXXXXXXX_LShareLookDesc',
  },
  NM_EDITS: {
    header: 'NMCO_HD_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareNMLogo',
    logo: 'NMCO_CD_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareNMLogo',
    card: 'NMCO_BX_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareEdit',
    desc: 'NMCO_CX_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareEditDesc',
  },
  BG_EDITS: {
    header: 'BGCO_HD_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareBGLogo',
    logo: 'BGCO_CD_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareBGLogo',
    card: 'BGCO_BX_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareEdit',
    desc: 'BGCO_CX_XXXX_SHES_XXXXXXXXXXXXXXXX_XXXXXXXX_EShareEditDesc',
  },
};

export const SPLIT_PAYMENT_TYPES = {
  EXACT_AMOUNT: 'EXACT_AMOUNT',
  SPLIT_EQUAL: 'SPLIT_EQUAL',
  PERCENTAGE: 'PERCENTAGE',
};

export const CENTS_ADJUSTER = 100;
export const MAX_PERCENT = 100;

export const ITEMS_IN_WISHLIST_PREVIEW = 4;

export const CLIENT_WISHLIST_STORAGE_NAME = 'clientForWishlist';

export const ENTRY_PAGES = {
  CLIENT_LIST_PAGE: 'clientListPage',
  REASON_TO_CONTACT_PAGE: 'reasonToContactPage',
};

export const NOTIFICATION_EVENTS = {
  DIGITAL_CLIENT_LEAD: 'DIGITAL_CLIENT_LEAD',
  SM_GROUP_MIGRATION: 'SM_GROUP_MIGRATION',
};

export const PLC_CARD_TYPES = ['PLC', 'NMS', 'BGS', 'NMR', 'BGR'];
export const PAYMENT_ERROR_MSG =
  'The transaction cannot be completed because there’s a balance owed. Please add additional funds to complete the transaction';
